import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
    static targets = ['tiles', 'controls'];

    static values = {
        mdMax: Number,
        xlMax: Number,
        enableAnimation: { type: Boolean, default: true },
    };

    connect() {
        this.tabletSliderQuery = window.matchMedia(`(max-width: ${this.xlMaxValue}px)`);
        this.phoneSliderQuery = window.matchMedia(`(max-width: ${this.mdMaxValue}px)`);
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
        this.setupEntranceAnimation = this.setupEntranceAnimation.bind(this);

        this.handleBreakpointChange();

        if (this.tabletSliderQuery.addEventListener) {
            this.tabletSliderQuery.addEventListener('change', this.handleBreakpointChange);
            this.phoneSliderQuery.addEventListener('change', this.handleBreakpointChange);
        } else {
            this.tabletSliderQuery.addListener(this.handleBreakpointChange);
            this.phoneSliderQuery.addListener(this.handleBreakpointChange);
        }

        if (!this.enableAnimationValue || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.element.classList.add('is-in-viewport');
            return;
        }

        requestAnimationFrame(() => {
            this.setupEntranceAnimation();
        });
    }

    disconnect() {
        this.entranceObserver?.disconnect();

        if (this.tabletSliderQuery?.removeEventListener) {
            this.tabletSliderQuery.removeEventListener('change', this.handleBreakpointChange);
            this.phoneSliderQuery.removeEventListener('change', this.handleBreakpointChange);
        } else {
            this.tabletSliderQuery?.removeListener(this.handleBreakpointChange);
            this.phoneSliderQuery?.removeListener(this.handleBreakpointChange);
        }

        this.destroySlider();
    }

    handleBreakpointChange() {
        this.destroySlider();

        if (this.tabletSliderQuery.matches) {
            this.initializeSlider();
        } else {
            this.toggleControlsVisibility(false);
        }
    }

    initializeSlider() {
        const $tiles = $(this.tilesTarget);
        const hasSlides = $tiles.children('.image-tile-grid__slide').length > 0;

        this.toggleControlsVisibility(hasSlides);

        if (!hasSlides) {
            return;
        }

        const isPhone = this.phoneSliderQuery.matches;

        $tiles.slick({
            appendArrows: $(this.controlsTarget),
            appendDots: $(this.controlsTarget),
            arrows: true,
            dots: true,
            draggable: true,
            infinite: false,
            rows: 0,
            slidesToScroll: 1,
            slidesToShow: isPhone ? 1.2 : 2,
            prevArrow: '<button class="slick-prev" type="button" aria-label="Previous slide"><i class="far fa-chevron-left" aria-hidden="true"></i></button>',
            nextArrow: '<button class="slick-next" type="button" aria-label="Next slide"><i class="far fa-chevron-right" aria-hidden="true"></i></button>',
        });
    }

    destroySlider() {
        const $tiles = $(this.tilesTarget);

        if ($tiles.hasClass('slick-initialized')) {
            $tiles.slick('unslick');
        }
    }

    toggleControlsVisibility(isVisible) {
        const wrap = this.controlsTarget.closest('.image-tile-grid__slider-controls-wrap');

        if (wrap) {
            wrap.hidden = !isVisible;
        }
    }

    setupEntranceAnimation() {
        if (!('IntersectionObserver' in window)) {
            requestAnimationFrame(() => {
                this.element.classList.add('is-in-viewport');
            });
            return;
        }

        this.entranceObserver = new IntersectionObserver(
            (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) {
                    return;
                }

                requestAnimationFrame(() => {
                    this.element.classList.add('is-in-viewport');
                    this.entranceObserver.disconnect();
                });
            },
            {
                rootMargin: '0px 0px -10% 0px',
                threshold: 0.15,
            },
        );
        this.entranceObserver.observe(this.element);
    }
}
